export default __webpack_public_path__ + "static/media/compras.cb8b2f9a.png";